module.exports = __webpack_public_path__ + "static/media/GCIPreAlertingAttentionSignal.242c7c12.mp3";